/* MGH premium hero carousel. Fixed 2026-10-23: removed stray trailing '})' that broke the script. */
(()=>{
  function init(root){
    if(root.dataset.mghInitialized==='true')return;
    const slides=[...root.querySelectorAll('[data-mgh-slide]')];
    const dots=[...root.querySelectorAll('[data-mgh-dot]')];
    if(!slides.length)return;
    root.dataset.mghInitialized='true';
    let current=0,timer=null,paused=false,x0=null;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplay=root.dataset.autoplay==='true'&&slides.length>1;
    const delay=Math.max(4000,Number(root.dataset.delay)||7000);
    const pauseButton=root.querySelector('[data-mgh-pause]');
    function show(next){
      current=(next+slides.length)%slides.length;
      slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});
      dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-current',String(i===current));});
    }
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function start(){stop();if(autoplay&&!paused&&!reduced.matches&&!document.hidden)timer=setInterval(()=>show(current+1),delay);}
    function go(n){show(n);start();}
    root.querySelector('[data-mgh-prev]')?.addEventListener('click',()=>go(current-1));
    root.querySelector('[data-mgh-next]')?.addEventListener('click',()=>go(current+1));
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
    pauseButton?.addEventListener('click',()=>{
      paused=!paused;
      pauseButton.setAttribute('aria-pressed',String(paused));
      pauseButton.setAttribute('aria-label',paused?'Play carousel':'Pause carousel');
      pauseButton.textContent=paused?'▶':'Ⅱ';
      start();
    });
    if(slides.length>1){
      root.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')go(current-1);else if(e.key==='ArrowRight')go(current+1);});
      root.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
      root.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45)go(current+(dx<0?1:-1));x0=null;},{passive:true});
    }
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))start();});
    const visibilityHandler=()=>document.hidden?stop():start();
    document.addEventListener('visibilitychange',visibilityHandler);
    reduced.addEventListener?.('change',start);
    root.mghCleanup=()=>{stop();document.removeEventListener('visibilitychange',visibilityHandler);reduced.removeEventListener?.('change',start);};
    show(0);start();
  }
  function initAll(scope=document){scope.querySelectorAll('[data-mgh-hero]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-mgh-hero]').forEach(root=>root.mghCleanup?.()));
  document.addEventListener('shopify:block:select',e=>{
    const slide=e.target.closest('[data-mgh-slide]');if(!slide)return;
    const root=slide.closest('[data-mgh-hero]');
    const index=[...root.querySelectorAll('[data-mgh-slide]')].indexOf(slide);
    root.querySelector(`[data-mgh-dot='${index}']`)?.click();
  });
})();
